import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LifeBuoy, X } from "lucide-react";
import { useApp } from "@/lib/store";

export default function SafetyLink({ compact = false }) {
  const [open, setOpen] = useState(false);
  const { content } = useApp();
  const safety = content?.safety;

  return (
    <>
      <button
        data-testid="safety-link"
        onClick={() => setOpen(true)}
        className="inline-flex items-center gap-2 text-[13px] text-[#6B6B6B] hover:text-[#1A1A1A] ss-focus transition-colors"
      >
        <LifeBuoy size={15} strokeWidth={1.5} />
        This feels more serious or urgent
      </button>

      <AnimatePresence>
        {open && safety && (
          <motion.div
            className="fixed inset-0 z-50 flex items-end justify-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <div className="absolute inset-0 bg-black/30" onClick={() => setOpen(false)} />
            <motion.div
              className="relative w-full max-w-md bg-[#FDFBF7] rounded-t-3xl p-6 pb-10 max-h-[85vh] overflow-y-auto"
              initial={{ y: 40 }}
              animate={{ y: 0 }}
              exit={{ y: 40 }}
              transition={{ duration: 0.2 }}
              data-testid="safety-sheet"
            >
              <div className="flex items-start justify-between mb-4">
                <h2 className="font-serif-display text-3xl">{safety.title}</h2>
                <button data-testid="safety-close" onClick={() => setOpen(false)} className="ss-focus p-1" aria-label="Close safety information">
                  <X size={22} strokeWidth={1.5} />
                </button>
              </div>
              <p className="text-sm text-[#474747] mb-4">{safety.intro}</p>
              <ul className="space-y-3 mb-5">
                {safety.points.map((p, i) => (
                  <li key={i} className="flex gap-3 text-[15px] leading-relaxed">
                    <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#C9A227] shrink-0" />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
              <p className="text-xs text-[#6B6B6B] leading-relaxed border-t border-[#EBE9E4] pt-4">
                {safety.disclaimer}
              </p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
